'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserTargetsContainerController = function () {
  function UserTargetsContainerController(performanceManagementService, lookupService, userService, $ngConfirm, $scope, $stateParams, growl, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserTargetsContainerController);
    this.performanceManagementService = performanceManagementService;
    this.lookupService = lookupService;
    this.userService = userService;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.growl = growl;
    this.loadingService = loadingService;

    this.years = [];
    this.entityUsers = [];
    this.brands = [];
    this.allBrandModels = [];
    this.vehicleConditionList = [];
    this.userTargets = [];

    this.selectedYear = null;
    this.emptyModel = { brandId: null, brandModelId: null, name: 'Please Select' };

    this.loadYears();
    this.loadEntityUsers();
    this.loadUserTargets();
    this.loadBrands();
    this.loadBrandModels();
    this.loadVehicleConditions();
  }

  (0, _createClass3.default)(UserTargetsContainerController, [{
    key: 'loadYears',
    value: function loadYears() {
      var startYear = 2014;
      var endYear = new Date().getFullYear();

      for (var i = endYear; i >= startYear - 1; i--) {
        this.years.push(i);
      }

      this.selectedYear = endYear;
    }
  }, {
    key: 'loadEntityUsers',
    value: function loadEntityUsers() {
      var _this = this;

      this.userService.getLocationUsers(this.$stateParams.locationId, true).then(function (response) {
        _this.entityUsers = response.data;
        _this.entityUsers.unshift({ entityUserId: null, firstName: 'Please', lastName: 'Select' });
      });
    }
  }, {
    key: 'loadUserTargets',
    value: function loadUserTargets() {
      var _this2 = this;

      this.loadingService.showLoading('userTargetsList', 'Loading User Targets ...');

      this.performanceManagementService.listUserTargets(this.$stateParams.locationId, this.selectedYear).then(function (response) {
        return _this2.userTargets = response.data;
      }).finally(function () {
        _this2.loadingService.hideLoading('userTargetsList');
      });
    }
  }, {
    key: 'loadBrands',
    value: function loadBrands() {
      var _this3 = this;

      this.lookupService.lookupBrands().then(function (brands) {
        return _this3.brands = brands;
      });
    }
  }, {
    key: 'loadBrandModels',
    value: function loadBrandModels() {
      var _this4 = this;

      this.lookupService.lookupBrandModels().then(function (brandModels) {
        return _this4.allBrandModels = brandModels;
      });
    }
  }, {
    key: 'loadVehicleConditions',
    value: function loadVehicleConditions() {
      this.vehicleConditionList.push({ id: 1, name: 'New' });
      this.vehicleConditionList.push({ id: 2, name: 'Used' });
    }
  }, {
    key: 'showAddTarget',
    value: function showAddTarget() {
      var _this5 = this;

      this.$scope.errMsg = '';
      this.$scope.entityUsers = this.entityUsers;
      this.$scope.brands = this.brands;
      this.$scope.allBrandModels = this.allBrandModels;
      this.$scope.emptyModel = this.emptyModel;
      this.$scope.brandModels = [this.emptyModel];
      this.$scope.vehicleConditionList = this.vehicleConditionList;
      this.$scope.filterBrandModels = this.filterBrandModels;

      this.$scope.userTarget = {
        entityId: this.$stateParams.locationId,
        entityUserId: null,
        year: this.selectedYear, //Selected Year
        condition: 1, //New
        brandId: 1, //Default to All Brands New or Used
        brandModelId: null,
        enquiriesCreated: 0,
        enquiriesDelivered: 0,
        financesReferred: 0,
        financesAccepted: 0
      };

      this.$ngConfirm({
        title: 'Add New Target',
        contentUrl: 'templates/performance/editUserTargetsTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              if (!_this5.validateAddTarget()) {
                return false;
              }

              _this5.addTarget();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'validateAddTarget',
    value: function validateAddTarget() {
      var utToAdd = this.$scope.userTarget;

      if (!utToAdd.entityUserId) {
        this.$scope.errMsg = 'Please select a user';

        return false;
      }

      if (this.getTargetTotal(utToAdd) <= 0) {
        this.$scope.errMsg = 'Please enter at least one value';

        return false;
      }

      var duplicate = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId);

      if (duplicate !== undefined) {
        this.$scope.errMsg = 'This configuration is already added';
        return false;
      }

      var brandId = utToAdd.brandId;
      var modelId = utToAdd.brandModelId;

      /*
      * If there is a Brand Specified, without any Model
      * We need to get total of all targets with makes
      * and the combined total should be less than All 
      */
      if (brandId && !modelId) {
        //Get All Distribution First
        var all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);

        //If All Category Exist, then we can find other brands under All
        if (all) {
          var brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
          brandTargets.push(utToAdd);
          var brandTargetsCombined = this.combineTargets(brandTargets);
          var target = this.isBelowLimit(brandTargetsCombined, all);

          if (target) {
            this.$scope.errMsg = 'Combined total of all brand(s) for target ' + target + ', exceeds the All Category';
            return false;
          }
        }
      }

      /*
      * If the Brand and BrandModel both specified
      * 1- If the Brand exists, we need to get the total of all distributions
      * under the Brand, and the combined total should be less than Brand
      * 2- If the Brand does not exist, we need to check the combined total
      * of this brandmodel along with any others brands under all category
      */
      if (brandId && modelId) {
        //Get Brand Distribution First
        var brand = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null);

        if (brand) {
          var brandModelTargets = this.findBrandModelTargets(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId) || [];
          brandModelTargets.push(utToAdd);
          var brandModelTargetsCombined = this.combineTargets(brandModelTargets);
          var _target = this.isBelowLimit(brandModelTargetsCombined, brand);

          if (_target) {
            this.$scope.errMsg = 'Combined total of all brand models(s) for the target of ' + _target + ', exceeds the All Category';
            return false;
          }
        } else {
          var _all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);

          if (_all) {
            var _brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
            _brandTargets.push(utToAdd);
            var _brandTargetsCombined = this.combineTargets(_brandTargets);
            var _target2 = this.isBelowLimit(_brandTargetsCombined, _all);

            if (_target2) {
              this.$scope.errMsg = 'Combined total of all brand(s) for the target of ' + _target2 + ', exceeds the All Category';
              return false;
            }
          }
        }
      }

      return true;
    }
  }, {
    key: 'addTarget',
    value: function addTarget() {
      var _this6 = this;

      this.loadingService.showLoading('userTargetsList', 'Adding User Target ...');

      this.performanceManagementService.addUserTarget(this.$scope.userTarget).then(function (response) {
        _this6.$scope.userTarget.userTargetId = response.data;
        var user = (0, _lodash.find)(_this6.entityUsers, function (o) {
          return o.entityUserId === _this6.$scope.userTarget.entityUserId;
        });
        _this6.$scope.userTarget.user = user.firstName + ' ' + user.lastName;
        _this6.$scope.userTarget.conditionText = (0, _lodash.find)(_this6.vehicleConditionList, function (o) {
          return o.id === _this6.$scope.userTarget.condition;
        }).name;
        _this6.$scope.userTarget.brandName = (0, _lodash.find)(_this6.brands, function (o) {
          return o.brandId === _this6.$scope.userTarget.brandId;
        }).name;
        var brandModel = (0, _lodash.find)(_this6.allBrandModels, function (o) {
          return o.brandModelId === _this6.$scope.userTarget.brandModelId;
        });
        _this6.$scope.userTarget.brandModelName = brandModel != null ? brandModel.name : '';

        _this6.userTargets.push(_this6.$scope.userTarget);

        _this6.growl.success('User Target added successfully', { ttl: 5000 });
      }).finally(function () {
        _this6.loadingService.hideLoading('userTargetsList');
      });
    }
  }, {
    key: 'showEditTarget',
    value: function showEditTarget(ut) {
      var _this7 = this;

      this.$scope.errMsg = '';
      this.$scope.entityUsers = this.entityUsers;
      this.$scope.brands = this.brands;
      this.$scope.allBrandModels = this.allBrandModels;
      this.$scope.emptyModel = this.emptyModel;
      this.$scope.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === ut.brandId;
      });
      this.$scope.vehicleConditionList = this.vehicleConditionList;
      this.$scope.filterBrandModels = this.filterBrandModels;

      this.$scope.userTarget = (0, _assign2.default)({}, ut);

      this.$ngConfirm({
        title: 'Edit User Target',
        contentUrl: 'templates/performance/editUserTargetsTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              if (!_this7.validateEditTarget()) {
                return false;
              }

              _this7.editTarget();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'validateEditTarget',
    value: function validateEditTarget() {
      var utToAdd = this.$scope.userTarget;

      if (this.getTargetTotal(utToAdd) <= 0) {
        this.$scope.errMsg = 'Please enter at least one value';
        return false;
      }

      var brandId = utToAdd.brandId;
      var modelId = utToAdd.brandModelId;

      debugger;
      /*
      * If there is a Brand Specified, without any Model
      * We need to get total of all targets with makes
      * and the combined total should be less than All 
      */
      if (brandId && brandId !== 1 && !modelId) {
        //Get All Distribution First
        var all = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);

        //If All Category Exist, then we can find other brands under All
        if (all) {
          var brandTargets = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
          //Exclude it self from Total
          brandTargets = (0, _lodash.without)(brandTargets, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null));
          brandTargets.push(utToAdd);
          var brandTargetsCombined = this.combineTargets(brandTargets);
          var target = this.isBelowLimit(brandTargetsCombined, all);

          if (target) {
            this.$scope.errMsg = 'Combined total of all brand(s) for target ' + target + ', exceeds the All Category';
            return false;
          }
        }
      }

      /*
      * If the Brand and BrandModel both specified
      * 1- If the Brand exists, we need to get the total of all distributions
      * under the Brand, and the combined total should be less than Brand
      * 2- If the Brand does not exist, we need to check the combined total
      * of this brandmodel along with any others brands under all category
      */
      if (brandId && modelId) {
        //Get Brand Distribution First
        var brand = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, null);

        if (brand) {
          var brandModelTargets = this.findBrandModelTargets(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId) || [];
          //Exclude it self from Total
          brandModelTargets = (0, _lodash.without)(brandModelTargets, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId));
          brandModelTargets.push(utToAdd);
          var brandModelTargetsCombined = this.combineTargets(brandModelTargets);
          var _target3 = this.isBelowLimit(brandModelTargetsCombined, brand);

          if (_target3) {
            this.$scope.errMsg = 'Combined total of all brand models(s) for the target of ' + _target3 + ', exceeds the All Category';
            return false;
          }
        } else {
          var _all2 = this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, 1, null);

          if (_all2) {
            var _brandTargets2 = this.findBrandTargets(utToAdd.entityUserId, utToAdd.condition) || [];
            //Exclude it self from Total
            _brandTargets2 = (0, _lodash.without)(_brandTargets2, this.findUserTarget(utToAdd.entityUserId, utToAdd.condition, utToAdd.brandId, utToAdd.brandModelId));
            _brandTargets2.push(utToAdd);
            var _brandTargetsCombined2 = this.combineTargets(_brandTargets2);
            var _target4 = this.isBelowLimit(_brandTargetsCombined2, _all2);

            if (_target4) {
              this.$scope.errMsg = 'Combined total of all brand(s) for the target of ' + _target4 + ', exceeds the All Category';
              return false;
            }
          }
        }
      }

      return true;
    }
  }, {
    key: 'editTarget',
    value: function editTarget() {
      var _this8 = this;

      this.loadingService.showLoading('userTargetsList', 'Updating User Target ...');

      this.performanceManagementService.editUserTarget(this.$scope.userTarget).then(function (response) {
        var ut = (0, _lodash.find)(_this8.userTargets, function (o) {
          return o.userTargetId === _this8.$scope.userTarget.userTargetId;
        });
        ut.enquiriesCreated = _this8.$scope.userTarget.enquiriesCreated;
        ut.enquiriesDelivered = _this8.$scope.userTarget.enquiriesDelivered;
        ut.financesReferred = _this8.$scope.userTarget.financesReferred;
        ut.financesAccepted = _this8.$scope.userTarget.financesAccepted;

        _this8.growl.success('Target Updated successfully', { ttl: 5000 });
      }).finally(function () {
        _this8.loadingService.hideLoading('userTargetsList');
      });
    }
  }, {
    key: 'showRemoveTarget',
    value: function showRemoveTarget(userTargetId) {
      var _this9 = this;

      this.$ngConfirm({
        title: 'Remove User Target',
        content: 'Are you sure you want to delete this Target ?',
        typeAnimation: false,
        type: 'red',
        buttons: {
          yes: {
            text: 'Delete',
            btnClass: 'btn-danger',
            action: function action() {
              _this9.removeTarget(userTargetId);
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'removeTarget',
    value: function removeTarget(userTargetId) {
      var _this10 = this;

      this.loadingService.showLoading('userTargetsList', 'Removing User Target ...');

      this.performanceManagementService.removeUserTarget(this.$stateParams.locationId, userTargetId).then(function (response) {
        var ut = (0, _lodash.find)(_this10.userTargets, function (o) {
          return o.userTargetId === userTargetId;
        });

        _this10.userTargets = (0, _lodash.without)(_this10.userTargets, ut);

        _this10.growl.success('Target Deleted successfully', { ttl: 5000 });
      }).finally(function () {
        _this10.loadingService.hideLoading('userTargetsList');
      });
    }
  }, {
    key: 'isPositive',
    value: function isPositive(number) {
      return number >= 0;
    }
  }, {
    key: 'filterBrandModels',
    value: function filterBrandModels(ut) {
      var _brandModels;

      this.brandModels = [this.emptyModel];
      (_brandModels = this.brandModels).push.apply(_brandModels, (0, _toConsumableArray3.default)((0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === ut.brandId;
      })));

      ut.brandModelId = null;
    }
  }, {
    key: 'getTargetTotal',
    value: function getTargetTotal(ut) {
      return ut.enquiriesCreated + ut.enquiriesDelivered + ut.financesReferred + ut.financesAccepted;
    }
  }, {
    key: 'findUserTarget',
    value: function findUserTarget(entityUserId, condition, brandId, brandModelId) {
      return (0, _lodash.find)(this.userTargets, function (o) {
        return o.entityUserId === entityUserId && o.condition === condition && o.brandId === brandId && o.brandModelId === brandModelId;
      });
    }
  }, {
    key: 'findBrandTargets',
    value: function findBrandTargets(entityUserId, condition) {
      return (0, _lodash.filter)(this.userTargets, function (o) {
        return o.entityUserId === entityUserId && o.condition === condition && o.brandId !== 1 && o.brandModelId === null;
      });
    }
  }, {
    key: 'findBrandModelTargets',
    value: function findBrandModelTargets(entityUserId, condition, brandId) {
      return (0, _lodash.filter)(this.userTargets, function (o) {
        return o.entityUserId === entityUserId && o.condition === condition && o.brandId === brandId && o.brandModelId !== null;
      });
    }
  }, {
    key: 'combineTargets',
    value: function combineTargets(targets) {
      var target = {};

      target.enquiriesCreated = (0, _lodash.sumBy)(targets, function (o) {
        return o.enquiriesCreated;
      });
      target.enquiriesDelivered = (0, _lodash.sumBy)(targets, function (o) {
        return o.enquiriesDelivered;
      });
      target.financesReferred = (0, _lodash.sumBy)(targets, function (o) {
        return o.financesReferred;
      });
      target.financesAccepted = (0, _lodash.sumBy)(targets, function (o) {
        return o.financesAccepted;
      });

      return target;
    }
  }, {
    key: 'isBelowLimit',
    value: function isBelowLimit(utToUpdate, utToCompare) {
      if (utToUpdate.enquiriesCreated > utToCompare.enquiriesCreated) {
        return "Enquiries Created";
      }

      if (utToUpdate.enquiriesDelivered > utToCompare.enquiriesDelivered) {
        return "Enquiries Delivered";
      }

      if (utToUpdate.financesReferred > utToCompare.financesReferred) {
        return "Finances Referred";
      }

      if (utToUpdate.financesAccepted > utToCompare.financesAccepted) {
        return "Finances Accepted";
      }

      return null;
    }
  }]);
  return UserTargetsContainerController;
}();

exports.default = UserTargetsContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/userTargetsManagement/userTargetsContainer/userTargetsContainer.controller.js